// extracted by mini-css-extract-plugin
var _1 = "ImageCarousel-module__animatedBackground--g_7fY";
var _2 = "ImageCarousel-module__container--LAvFg";
var _3 = "ImageCarousel-module__controlsContainer--oiWSF";
var _4 = "ImageCarousel-module__thumbnailBarContainer--BEE2D";
var _5 = "ImageCarousel-module__xsmall--ZCaxi";
export { _1 as "animatedBackground", _2 as "container", _3 as "controlsContainer", _4 as "thumbnailBarContainer", _5 as "xsmall" }
